function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import c from 'classnames';
import GenericFormElement from '../GenericFormElement';
import SelectInput from './Input';
import { useExtendedFormikContext } from '../FormikWrapper';
import getNestedFieldvalue from '../getNestedFieldvalue';
import './style.scss';
var Select = function Select(props) {
  var title = props.title,
    fieldName = props.fieldName,
    required = props.required,
    description = props.description,
    className = props.className,
    wrapperClassName = props.wrapperClassName,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? false : _props$multiple,
    _props$isSearchable = props.isSearchable,
    isSearchable = _props$isSearchable === void 0 ? true : _props$isSearchable,
    _props$isClearable = props.isClearable,
    isClearable = _props$isClearable === void 0 ? true : _props$isClearable,
    validation = props.validation,
    includeFieldSet = props.includeFieldSet,
    descriptionAboveInput = props.descriptionAboveInput;
  var _useExtendedFormikCon = useExtendedFormikContext(),
    errors = _useExtendedFormikCon.errors,
    touched = _useExtendedFormikCon.touched,
    displayRequiredIndicator = _useExtendedFormikCon.displayRequiredIndicator,
    setFieldTouched = _useExtendedFormikCon.setFieldTouched;
  var isTouched = getNestedFieldvalue(fieldName, touched);
  var error = getNestedFieldvalue(fieldName, errors);
  var errorId = "".concat(props.fieldName, "--error");
  var descriptionId = "".concat(props.fieldName, "--description");
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    className: c('Select', wrapperClassName),
    title: title,
    required: required,
    description: description,
    fieldName: fieldName,
    touched: isTouched,
    error: error,
    displayRequiredIndicator: displayRequiredIndicator,
    errorId: errorId,
    descriptionId: descriptionId,
    includeFieldSet: includeFieldSet,
    descriptionAboveInput: descriptionAboveInput
  }, /*#__PURE__*/React.createElement(SelectInput, _extends({}, props, {
    fieldName: fieldName,
    className: c(className, {
      'error': error && isTouched
    }),
    disabled: disabled,
    multiple: multiple,
    isSearchable: isSearchable,
    isClearable: isClearable,
    isTouched: isTouched,
    required: required,
    validate: validation,
    error: error,
    errorId: errorId,
    onBlur: function onBlur() {
      setFieldTouched(fieldName, true, false);
    }
  })));
};
export default Select;